import * as React from "react";

export class MainPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        
        }
    }

    componentDidMount() {
        var options = {
            channel: "shroud",
            playsinline: true,
        };
        var player = new Twitch.Player("player", options);
        player.setVolume(0.5);
    }

    render() {
        return (
            <div className="content">
                <div className="background" />
                <div className="player" id="player" />
                {/* <div className="header">
                    Welcome to Warp Prism
                </div> */}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./react/components/MainPanel.jsx